import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';

const messages = defineMessages({
  download: {
    id: 'Download',
    defaultMessage: 'Scarica',
  },
});

interface DownloadProps {
  file: object;
  title?: string;
}

export const hasDownload = (file) => {
  return file?.download;
};

const DownloadButton: React.FC<DownloadProps> = ({ file, title }) => {
  const intl = useIntl();
  if (!file || !hasDownload(file)) {
    return null;
  }

  const label = title ?? intl.formatMessage(messages.download);

  return (
    <div className="download-button">
      <Button
        inverted
        primary
        as="a"
        href={flattenToAppURL(file.download)}
        target="_blank"
        title={label}
      >
        {label}
      </Button>
    </div>
  );
};

export default DownloadButton;
